import { AfterViewInit, Component, effect, ElementRef, input, InputSignal, Renderer2, signal } from '@angular/core';
import { LoadPdfIframeService } from './LoadPdfIframeService';

@Component({
    selector: 'pdf-viewer',
    template: '<iframe #iframe style="width: 100%; height: 100%;"></iframe>',
    standalone: false
})
export class PDFViewerComponent implements AfterViewInit {
    constructor(private _loadPdfIframeService: LoadPdfIframeService,
                private _elRef: ElementRef,
                private _renderer: Renderer2) {
        let pdfInitialized = false;
        let fileUrl: string;
        effect(() => {
            if (!this.iframe() || !this.fileUrl() || this.fileUrl() === fileUrl) {
                return;
            }
            fileUrl = this.fileUrl();

            if (!pdfInitialized) {
                this._loadPdfIframeService.initializePdfJs(this.iframe(), this.fileUrl());
                pdfInitialized = true;
                return;
            }

            // To prevent the iframe from creating a navigation event, we remove and recreate it
            this.iframe().remove();
            const iframe = this._renderer.createElement('iframe');
            this._renderer.setStyle(iframe, 'width', '100%');
            this._renderer.setStyle(iframe, 'height', '100%');

            this._loadPdfIframeService.updatePdfJs(iframe, this.fileUrl());

            this._renderer.appendChild(this._elRef.nativeElement, iframe);
            this.iframe.set(iframe);
        });
    }

    fileUrl: InputSignal<string> = input<string>('');
    iframe = signal<HTMLIFrameElement | null>(null);

    ngAfterViewInit(): void {
        this.iframe.set(this._elRef.nativeElement.querySelector('iframe'));
    }
}
